import isEmpty from 'lodash/isEmpty';

import { SearchParams, SearchTypes, SearchTypesHistory, SearchParamsHistory } from 'components/TripSearch/models';

export enum CheckBy {
  SearchTypes = 'SearchTypes',
  SearchTypesHistory = 'SearchTypesHistory',
}

export function checkFilterTagsMapper(
  defaultInitDate: string | undefined,
  defaultEndDate: string | undefined,
  checkBy: CheckBy,
  searchParams?: SearchParams | SearchParamsHistory,
): boolean {
  if (!searchParams) return false;
  if (isEmpty(searchParams)) return false;
  if (checkByType(checkBy, searchParams.type)) return false;
  if (searchParams.initDate && searchParams.endDate) {
    if (
      defaultInitDate &&
      defaultEndDate &&
      searchParams.initDate === defaultInitDate &&
      searchParams.endDate === defaultEndDate
    ) {
      return false;
    } else if (searchParams.initDate && searchParams.endDate) return true;
  }
  const keys = Object.entries(searchParams).filter(
    ([k, v]) =>
      k !== 'initDate' &&
      k !== 'endDate' &&
      k !== 'maxItemsPerPage' &&
      k !== 'page' &&
      k !== 'userId' &&
      k !== 'type' &&
      v !== undefined,
  );
  if (keys.length > 0) {
    return true;
  }
  return false;
}

function checkByType(checkBy: CheckBy, type: string | undefined): boolean {
  switch (checkBy) {
    case CheckBy.SearchTypes:
      return isntSearchBySearchTypes(type as SearchTypes);
    case CheckBy.SearchTypesHistory:
      return isntSearchBySearchTypesHistory(type as SearchTypesHistory);
    default:
      return false;
  }
}

function isntSearchBySearchTypesHistory(type: SearchTypesHistory): boolean {
  return type === SearchTypesHistory.week || type === SearchTypesHistory.month;
}

function isntSearchBySearchTypes(type: SearchTypes): boolean {
  return type === SearchTypes.next || type === SearchTypes.prev;
}
